import { render, staticRenderFns } from "./DcsDetail.vue?vue&type=template&id=176040e6&scoped=true&"
import script from "./DcsDetail.vue?vue&type=script&lang=js&"
export * from "./DcsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DcsDetail.vue?vue&type=style&index=0&id=176040e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176040e6",
  null
  
)

export default component.exports